import { useAttachmentFieldCommit as useSharedFieldCommit } from '@features/Attachments/hooks/useAttachmentFieldCommit';
import { translate } from '@utils/i18n';
import { EDIT_MODAL_ERRORS_NS, INVOICE_ATTACHMENTS_ENTITY_KEY } from '../constants';
import { updateInvoiceAttachment } from '../services/invoiceAttachmentsApi';
/** Invoice's binding of the shared single-field commit. */
export function useAttachmentFieldCommit(invoiceId, attachmentId) {
    return useSharedFieldCommit({
        entityKey: INVOICE_ATTACHMENTS_ENTITY_KEY,
        ownerId: invoiceId,
        attachmentId,
        update: updateInvoiceAttachment,
        genericErrorMessage: translate('generic', { namespace: EDIT_MODAL_ERRORS_NS })
    });
}
